import type { ComponentProps, CSSProperties } from "react";

import { cn } from "../utils";

import type { DlContextValue } from "./context";
import { DEFAULT_DL_CONTEXT_VALUE, DlContext, useDlContext } from "./context";

type Props = ComponentProps<"dl"> & Partial<DlContextValue>;

function Dl({
  gap = DEFAULT_DL_CONTEXT_VALUE.gap,
  descriptionOffset = DEFAULT_DL_CONTEXT_VALUE.descriptionOffset,
  ...props
}: Props) {
  return (
    <DlContext
      value={{
        gap,
        descriptionOffset,
      }}
    >
      <dl {...props} />
    </DlContext>
  );
}

type DtProps = ComponentProps<"dt">;

function Dt({ style, className, ...props }: DtProps) {
  const { gap } = useDlContext();

  return (
    <dt
      style={
        {
          "--gap": gap,
          ...style,
        } as CSSProperties
      }
      className={cn("text-card-foreground font-bold [&:not(:first-child)]:mt-(--gap)", className)}
      {...props}
    />
  );
}

type DdProps = ComponentProps<"dd">;

function Dd({ style, className, ...props }: DdProps) {
  const { descriptionOffset } = useDlContext();

  return (
    <dd
      style={
        {
          "--description-offset": descriptionOffset,
          ...style,
        } as CSSProperties
      }
      className={cn("pl-(--description-offset) break-words", className)}
      {...props}
    />
  );
}

export { Dd, Dl, Dt };
